<template>
  <div class="page-content cl-shopSale-detail-report">
    <h1 class="page-title">{{ $locale("CL.incidentalTable") }}</h1>
    <!-- Search Area -->
    <el-form :model="onSearch" :rules="formRules" class="search-area">
      <el-row>
        <el-col :span="5">
          <el-form-item prop="selectDate" :label="$locale('CL.dateOfAttraction')">
            <CommDatePicker
              v-model="onSearch.selectDate"
              :value.sync="onSearch.selectDate"
              width="100%"
              :showWeekly="true"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
            <el-form-item prop="cinemaId" :label="$locale('filmFeePdf.targetTheater')">
              <el-select v-model="onSearch.cinemaId">
                <el-option
                  v-for="item in cinemaList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="8" class="btn">
          <el-button
            :disabled="!onSearch.selectDate || !onSearch.cinemaId"
            class="egl-btn-yellow egl-btn-download download"
            @click="downloadPdf"
          >{{ $locale("global.download") }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <pdf-viewer
      ref="report"
      pdfOrientation="landscape"
      pdfContentWidth="100%"
      :filename="$locale('pdf.shopSale.tableName')"
    >
      <PdfShopSaleDetail :pdfData="pdfData" />
    </pdf-viewer>
  </div>
</template>
<script>
import { getCinemaList } from "@/helpers/service/api/common.js";
import PdfViewer from "@/components/common/PDFViewer";
import PdfShopSaleDetail from "@/components/PdfShopSaleDetail/pdfShopSaleDetail.vue";
import { pdfShopSaleDetailService } from "@/helpers/service/api/CL";
import CommDatePicker from "@/components/common/CommDatePicker";
export default {
  name: "cl-shopSale-detail-report",
  async created() {
    await getCinemaList().then(res => {
      this.cinemaList = res.data.data;
    });
  },
  data() {
    return {
      onSearch: {
        selectDate: this.$moment().startOf("day").valueOf(),
        cinemaId: "",
      },
      cinemaList: [],
      formRules: {
        selectDate: [ { required: true } ],
        cinemaId: [ { required: true } ]
      },
      pdfData: {},
      download: false,
    };
  },
  methods: {
    async downloadPdf() {
      pdfShopSaleDetailService({
        cinemaId: this.onSearch.cinemaId,
        monthDate: this.$moment(this.onSearch.selectDate).format("YYYY-MM-DD")
      }).then(res => {
        this.pdfData = res.data;
        this.printPdf();
      });
    },
    printPdf() {
      this.$refs.report.generateReport();
    }
  },
  components: {
    PdfViewer,
    PdfShopSaleDetail,
    CommDatePicker
  }
};
</script>
<style scoped lang="less">
.cl-shopSale-detail-report {
  position: relative;
  overflow: hidden;

  .el-col {
    margin-bottom: 5px;
  }
  .makeInline {
    white-space: nowrap;
  }
  .pdf-viewer {
    position: absolute;
    z-index: -1;
  }
  .search-area {
    .datepicker {
      display: flex;

      .el-input {
        padding: 0 10px;
      }
    }
    .download {
      margin-top: 40px;
    }
  }
}
</style>
